import { toaster } from "@/components/ui/toaster";
import { TFunction } from "i18next";

const TOAST_DURATION = 5000;

const showSessionExpiredToast = (t: TFunction) => {
    toaster.create({
        id: "sessionExpired",
        title: t("sessionExpiredTitle"),
        description: t("sessionExpiredDesc"),
        type: "warning",
        duration: TOAST_DURATION,
        closable: true
    });
};

export { showSessionExpiredToast };
